import React, { useState, useEffect, useContext } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

import Snackbar from '@material-ui/core/Snackbar';
import Slide from '@material-ui/core/Slide';
import Alert from '@material-ui/lab/Alert';

import { SessionContext } from "../context/session-context";

const useStyles = makeStyles({
    root: {
        paddingLeft:20,
    },
    clientLabel:{
        padding: 5,
    },
    textField:{
        width:'90%',
        maxWidth: 500,
    },
    clientButton:{
        width: 160,
        padding: 5,
        marginRight:20,
    }
});

var handleError = function (err) {
    console.log(err);
    return new Response(JSON.stringify({
      code: 400,
      message: 'Stupid network Error'
    }));
  };

export default function UserForm(props) {
    const classes = useStyles();
    const [sState, sDispatch] = useContext(SessionContext);
    const [username, setUsername] = useState('');
    const [companyid, setCompanyid] = useState(0);
    const [userid, setUserid] = useState(0);
    const [email, setEmail] = useState('');
    const [utype, setUtype] = useState('user');
    const [status, setStatus] = useState('active');
    const [lastactivity, setLastactivity] = useState('');
    const [newpassword, setNewpassword] = useState('');

    const [severity, setSeverity] = useState('success');
    const [msg, setMsg] = useState('');
    const [snackOpen, setSnackOpen] = useState(false);


    useEffect(() => {
        setCompanyid(props.user.companyid)
        setUserid(props.user.userid);
        setUsername(props.user.username);
        setEmail(props.user.email);
        setUtype(props.user.utype)
        setStatus(props.user.status);

        const dt = new Date(props.user.lastactivity);
        const activeDate = ('0'+dt.getDate()).slice(-2)+'/'+ ('0'+(dt.getMonth()+ 1)).slice(-2) +'/'+dt.getFullYear()+' '+('0'+dt.getHours()).slice(-2)+':'+('0'+dt.getMinutes()).slice(-2);
        setLastactivity(activeDate);
    },[props.user])

    useEffect(() => {
        if (props.companyid !== companyid){
            setCompanyid(props.companyid)
            setUserid(-1);
            setUsername('');
            setEmail('');
            setUtype('user')
            setStatus('active');
            setLastactivity('');
        }
    },[props.companyid])

    const handleUserUpdate = () => {
        const user = {
            userid:userid,
            companyid:companyid,
            username:username,
            email:email,
            utype:utype,
            status:status
        }
        saveUser(user, sDispatch, 'update');
        props.updated();
    };

    const handleUserAdd = () => {
        const user = {
            userid:-1,
            companyid:parseInt(props.companyid),
            username:username,
            email:email,
            utype:utype,
            status:status
        }
        saveUser(user, sDispatch, 'add');
        props.updated();
    };

    const saveUser = (user, sDispatch, type)  => {

        const abortController = new AbortController();
    
        const request = {   
            companyid:user.companyid,
            userid:user.userid,
            username:user.username,
            email:user.email,
            utype:user.utype,
            status:user.status
        };
    
        let mounted = true;
        (async () => {  
            const res = await fetch(process.env.REACT_APP_FIND_API+'/find/user/save', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(request),
            signal: abortController.signal,
            }).catch(handleError);
            const data = await res.json();
            if (mounted) {
                if (data.status === "success"){
                    sDispatch({
                        type: "setUserList",
                        payload: { userList: data.users }
                    });

                    setSeverity('success')
                    if (type === 'add'){
                        setMsg('User has been successfully added.');
                    } else {
                        setMsg('User has been successfully updated.');
                    }
                    
                } else {
                    setSeverity('error')
                    switch (data.message){
                        case "email_already_exist":
                            setMsg('Email address is already in use.');
                        break;
                        default:
                            setMsg(data.message);
                        break;

                    }
                    
                }
                setSnackOpen(true);
            }
            const cleanup = () => {
                mounted = false;
                abortController.abort();
            };
            return cleanup;
        
        })();
    }

    const handleSnackClose=()=>{
        setSnackOpen(false);
    }

    const handleUserPasswordSet = (user) => {

        const abortController = new AbortController();
    
        const request = {   
            userid:userid,
            companyid:companyid,
            username:username,
            email:email,
            utype:utype,
            status:status
        };

        let mounted = true;
        (async () => {  
            const res = await fetch(process.env.REACT_APP_FIND_API+'/admin/update/userpassword', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(request),
            signal: abortController.signal,
            }).catch(handleError);
            const data = await res.json();
            if (mounted) {


                if (data.status === "success"){
                    setSeverity('success')
                    setMsg('User password has been updated.');
                } else {
                    setSeverity('error')
                    switch (data.message){
                        case "email_already_exist":
                            setMsg('Email address is already in use.');
                        break;
                        default:
                            setMsg(data.message);
                        break;

                    }
                    
                }
                setSnackOpen(true);
            }
            const cleanup = () => {
                mounted = false;
                abortController.abort();
            };
            return cleanup;
        
        })();



    };
    /*
    <Grid item xs={12}>
        <TextField className={classes.textField} name="newuserpassword" label="Set user password" size="small" margin="dense" variant="outlined" value={newpassword} onChange={e => setNewpassword(e.target.value)}/> 
        <Button className={classes.clientButton} variant="contained" onClick={handleUserPasswordSet} >
            <Box fontWeight="fontWeightRegular" fontSize={12} >Set user password</Box>
        </Button>
    </Grid>
    */

    return (
        <div className={classes.root}>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={snackOpen}
                autoHideDuration={6000}
                onClose={handleSnackClose}
                TransitionComponent={Slide}
                TransitionProps={{ direction: 'down' }}
            >
                <Alert onClose={handleSnackClose} severity={severity}>
                {msg}
                </Alert>
            </Snackbar>
            <Grid container>
                <Grid item xs={12}>
                    <Box className={classes.clientLabel} fontSize={16} >{props.companyname}</Box>
                    <TextField className={classes.textField} name="username" label="Full name" size="small" margin="dense" variant="outlined" value={username} onChange={e => setUsername(e.target.value)}/> 
                    <TextField type="email" className={classes.textField} name="email" label="Email" size="small" margin="dense" variant="outlined" value={email} onChange={e => setEmail(e.target.value)}/>
                    <TextField className={classes.textField} name="utype" label="User Type" size="small" margin="dense" variant="outlined" value={utype} onChange={e => setUtype(e.target.value)} select>
                        <MenuItem value={'user'}>User</MenuItem>
                        <MenuItem value={'manager'}>Manager</MenuItem>
                        <MenuItem value={'admin'}>Admin (FIND only)</MenuItem>
                    </TextField> 
                    <TextField className={classes.textField} name="status" label="Status" size="small" margin="dense" variant="outlined" value={status} onChange={e => setStatus(e.target.value)} select>
                        <MenuItem value={'active'}>Active</MenuItem>
                        <MenuItem value={'disabled'}>Disabled</MenuItem>
                    </TextField>
                    <Box fontSize={12} >Last activity: {lastactivity}</Box>
                </Grid>
                <Grid item xs={12}>
                    <Button className={classes.clientButton} variant="contained" onClick={handleUserUpdate} >
                        <Box fontWeight="fontWeightRegular" fontSize={12} >Update</Box>
                    </Button>
                    <Button className={classes.clientButton} variant="contained" onClick={handleUserAdd} >
                        <Box fontWeight="fontWeightRegular" fontSize={12} >Add as new user</Box>
                    </Button>
                </Grid>
            </Grid>
        </div>
    )
  };
